// Canonical business hours (per-day, industry standard): the ONE owner for both apps (2026-10-29).
// `company_settings.business_hours` is the single source of truth: one entry per day, keyed by
// NAME (no 0-vs-1-vs-7 ambiguity), each with its own open flag + hours. The legacy
// business_hours_start/end + working_days columns are DERIVED from it on save (CLAUDE.md §17).
// Moved here from apps/contractor-app/src/utils/smartScheduling.js (which re-exports these) so
// the customer portal reads the same hours the contractor app and the slot engine obey.

export const DAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']; // index = weekday (0=Sun)

export const DEFAULT_BUSINESS_HOURS = {
  monday:    { open: true,  start: '08:00', end: '17:00' },
  tuesday:   { open: true,  start: '08:00', end: '17:00' },
  wednesday: { open: true,  start: '08:00', end: '17:00' },
  thursday:  { open: true,  start: '08:00', end: '17:00' },
  friday:    { open: true,  start: '08:00', end: '17:00' },
  saturday:  { open: false, start: '09:00', end: '14:00' },
  sunday:    { open: false, start: '09:00', end: '14:00' }
};

// Coerce any stored value into a complete 7-day object (fills missing days).
export const normalizeBusinessHours = (raw) => {
  const out = {};
  for (const name of DAY_NAMES) {
    const d = raw && typeof raw === 'object' ? raw[name] : null;
    const def = DEFAULT_BUSINESS_HOURS[name];
    out[name] = {
      open: d ? !!d.open : def.open,
      start: (d && d.start ? String(d.start) : def.start).slice(0, 5),
      end: (d && d.end ? String(d.end) : def.end).slice(0, 5)
    };
  }
  return out;
};

// The envelope across OPEN days: weekday indexes that are open, earliest start, latest end.
// start/end are null when no day is open.
export const businessHoursEnvelope = (bh) => {
  const openIdxs = [];
  let start = null, end = null;
  DAY_NAMES.forEach((name, idx) => {
    const d = bh && bh[name];
    if (d && d.open) {
      openIdxs.push(idx);
      if (start === null || d.start < start) start = d.start;
      if (end === null || d.end > end) end = d.end;
    }
  });
  return { openIdxs, start, end };
};
